export var OrderTicketRedemptionCardRequestType;
(function(OrderTicketRedemptionCardRequestType) {
    OrderTicketRedemptionCardRequestType[/**
     * A request to add an [[OrderTicketRedemptionCard]] of type [[TicketRedemptionCardType.ThirdPartyMemberCard]].
     */ "ThirdPartyMemberCard"] = "ThirdPartyMemberCard";
    OrderTicketRedemptionCardRequestType[/**
     * A request to add a stored [[MemberTicketRedemptionCard]] for the authenticated [[Member]].
     */ "MemberTicketRedemptionCard"] = "MemberTicketRedemptionCard";
})(OrderTicketRedemptionCardRequestType || (OrderTicketRedemptionCardRequestType = {}));

//# sourceMappingURL=order-ticket-redemption-card-request-type.js.map